import React, { useState, useEffect } from 'react';
import isEqual from 'lodash/isEqual';
import styled from 'styled-components';
import useCollapse from 'react-collapsed';

import ChevronDownIcon from 'components/common/icons/stroke/chevron-down-stroke';
import ChevronUpIcon from 'components/common/icons/stroke/chevron-up-stroke';

const Collapse = ({ 'data-aid': dataAid, children, className, footer, header, isActive }) => {
  const [isExpanded, setExpanded] = useState(isActive);
  const [mousePosition, setMousePosition] = useState({ clientX: 0, clientY: 0 });
  const { getCollapseProps } = useCollapse({
    isExpanded,
  });

  useEffect(() => {
    setExpanded(isActive);
  }, [isActive, setExpanded]);

  const onMouseDown = ({ clientX, clientY }) => {
    setMousePosition({ clientX, clientY });
  };

  const onMouseUp = ({ clientX, clientY }) => {
    if (isEqual({ clientX, clientY }, mousePosition)) {
      setExpanded(x => !x);
    }
  };

  return (
    <StyledContainer className={className} data-aid={dataAid}>
      {header && (
        <StyledHeader onMouseDown={onMouseDown} onMouseUp={onMouseUp}>
          {header}
          <StyledIcon>{isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}</StyledIcon>
        </StyledHeader>
      )}
      <div {...getCollapseProps()}>
        <StyledContent>{children}</StyledContent>
        {footer && <StyledFooter>{footer}</StyledFooter>}
      </div>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  background: ${p => p.theme.colors.white};
  border: 1px solid ${p => p.theme.colors.gray300};
  box-sizing: border-box;
  border-radius: 8px;
`;

export const StyledHeader = styled.div`
  position: relative;
  padding: 0px 16px 10px 16px;

  &:hover {
    cursor: pointer;
  }

  h3 {
    margin: 8px 0 0 0;
  }
`;

const StyledFooter = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  padding: 12px 16px;
  border-top: 1px solid ${p => p.theme.colors.gray300};
`;

export const StyledIcon = styled.div`
  position: absolute;
  top: 5px;
  right: 20px;
  width: 24px;
  height: 24px;
  fill: ${p => p.theme.colors.gray600};
  cursor: pointer;
`;

export const StyledContent = styled.div`
  padding: 16px;
`;

export default Collapse;
